// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"DropzoneUploaded_dropzone__2V82J","innerText":"DropzoneUploaded_innerText__1tsa1","textColor":"DropzoneUploaded_textColor__2JVtT"};